window.slate = window.slate || {};
window.theme = window.theme || {};
 
/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {
  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function ($element) {
    var focusClass = 'js-focus-hidden';

    $element
      .first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first().removeClass(focusClass).removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function () {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function () {
    $('a[href*=#]').on(
      'click',
      function (evt) {
        this.pageLinkFocus($(evt.currentTarget.hash));
      }.bind(this)
    );
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function (options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function (evt) {
      if (
        options.$container[0] !== evt.target &&
        !options.$container.has(evt.target).length
      ) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function (options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  },
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function () {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled) {
      document.cookie = 'testcookie';
      cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
    }
    return cookieEnabled;
  },
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {
  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function (array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function (array, key, value) {
    var i = array.length;
    while (i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function (array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function (value, defaultValue) {
    return value == null || value !== value ? defaultValue : value;
  },
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function (options) {
    var tableWrapperClass =
      typeof options.tableWrapperClass === 'undefined'
        ? ''
        : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function (options) {
    var iframeWrapperClass =
      typeof options.iframeWrapperClass === 'undefined'
        ? ''
        : options.iframeWrapperClass;

    options.$iframes.each(function () {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');

      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  },
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function (container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container,
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function (evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function (evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      'id',
      evt.detail.sectionId
    );

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(
      this.instances,
      'id',
      evt.detail.sectionId
    );
  },

  _onSelect: function (evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      'id',
      evt.detail.sectionId
    );

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function (evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      'id',
      evt.detail.sectionId
    );

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function (evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      'id',
      evt.detail.sectionId
    );

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function (evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      'id',
      evt.detail.sectionId
    );

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function (evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      'id',
      evt.detail.sectionId
    );

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function (type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(
      function (index, container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  },
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney,
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function () {
  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(
      /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/
    );

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(
      /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
    );

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol,
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function () {
  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on(
      'change',
      this._onSelectChange.bind(this)
    );
  }

  Variants.prototype = $.extend({}, Variants.prototype, {
    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function () {
      var currentOptions = $.map(
        $(this.singleOptionSelector, this.$container),
        function (element) {
          var $element = $(element);
          var type = $element.attr('type');
          var currentOption = {};

          if (type === 'radio' || type === 'checkbox') {
            if ($element[0].checked) {
              currentOption.value = $element.val();
              currentOption.index = $element.data('index');

              return currentOption;
            } else {
              return false;
            }
          } else {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          }
        }
      );

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function () {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function (variant) {
        var satisfied = true;

        selectedValues.forEach(function (option) {
          if (satisfied) {
            satisfied = option.value === variant[option.index];
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function () {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant,
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function (variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (
        !variant.featured_image ||
        variantImage.src === currentVariantImage.src
      ) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant,
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function (variant) {
      if (
        variant.price === this.currentVariant.price &&
        variant.compare_at_price === this.currentVariant.compare_at_price
      ) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant,
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function (variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl =
        window.location.protocol +
        '//' +
        window.location.host +
        window.location.pathname +
        '?variant=' +
        variant.id;
      window.history.replaceState({ path: newurl }, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function (variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    },
  });

  return Variants;
})();

/*================ Utilities ================*/
/**
 * Responsive Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Responsive utility.
 *
 * @namespace Responsive
 */

theme.Responsive = (function () {
  function Responsive() {
    _classCallCheck(this, Responsive);

    this.currentBreakpoint = Responsive.getCurrentBreakpoint();

    window.addEventListener('resize', function () {
      var newBreakpoint = Responsive.getCurrentBreakpoint();

      if (this.currentBreakpoint === newBreakpoint) {
        return;
      }

      document.dispatchEvent(
        new CustomEvent('breakpoint:changed', {
          detail: {
            previousBreakpoint: this.currentBreakpoint,
            currentBreakpoint: newBreakpoint,
          },
        })
      );

      this.currentBreakpoint = newBreakpoint;
    });
  }

  Responsive.prototype.matchesBreakpoint = function (breakpoint) {
    switch (breakpoint) {
      case 'small':
        return window.matchMedia('screen and (max-width: 640px)').matches;

      case 'medium':
        return window.matchMedia(
          'screen and (min-width: 641px) and (max-width: 1007px)'
        ).matches;

      case 'medium-up':
        return window.matchMedia('screen and (min-width: 641px)').matches;

      case 'medium-down':
        return window.matchMedia('screen and (max-width: 1007px)').matches;

      case 'large':
        return window.matchMedia(
          'screen and (min-width: 1008px) and (max-width: 1279px)'
        ).matches;

      case 'large-up':
        return window.matchMedia('screen and (min-width: 1008px)').matches;

      case 'desktop':
        return window.matchMedia('screen and (min-width: 1280px)').matches;

      case 'widescreen':
        return window.matchMedia('screen and (min-width: 1600px)').matches;
    }
  };

  Responsive.prototype.getCurrentBreakpoint = function () {
    if (window.matchMedia('screen and (max-width: 640px)').matches) {
      return 'small';
    }

    if (
      window.matchMedia('screen and (min-width: 641px) and (max-width: 1007px)')
        .matches
    ) {
      return 'medium';
    }

    if (
      window.matchMedia(
        'screen and (min-width: 1008px) and (max-width: 1279px)'
      ).matches
    ) {
      return 'large';
    }

    if (window.matchMedia('screen and (min-width: 1280px)').matches) {
      return 'desktop';
    }
  };

  return Responsive;
})();

/**
 * Carousels Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Carousel utility.
 *
 * @namespace Carousels
 */

theme.Carousels = (function () {
  function Carousels(element) {
    var options =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Carousels);

    this.element = element;
    this.initialConfig = $(element).data('flickity-config');
    this.options = options;

    // console.log(this.initialConfig);

    this._attachListeners();
    this._build();
  }

  Carousels.prototype.destroy = function () {
    this.flickityInstance.destroy();

    if (this.initialConfig['breakpoints'] !== undefined) {
      document.removeEventListener(
        'breakpoint:changed',
        this._onBreakpointChangedListener
      );
    }
  };

  Carousels.prototype.selectCell = function (index) {
    var shouldPause =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var shouldAnimate =
      arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    if (shouldPause) {
      this.flickityInstance.pausePlayer();
    }

    this.flickityInstance.select(index, false, !shouldAnimate);
  };

  Carousels.prototype.pausePlayer = function () {
    this.flickityInstance.pausePlayer();
  };

  Carousels.prototype.unpausePlayer = function () {
    this.flickityInstance.unpausePlayer();
  };

  Carousels.prototype.resize = function () {
    this.flickityInstance.resize();
  };

  Carousels.prototype.getSelectedIndex = function () {
    return this.flickityInstance.selectedIndex;
  };

  Carousels.prototype.getSelectedCell = function () {
    return this.flickityInstance.selectedCell.element;
  };

  Carousels.prototype._attachListeners = function () {
    if (this.initialConfig['breakpoints'] !== undefined) {
      this._onBreakpointChangedListener = this._onBreakpointChanged.bind(this);
      document.addEventListener(
        'breakpoint:changed',
        this._onBreakpointChangedListener
      );
    }
  };

  /**
   * Create the carousel instance
   */

  Carousels.prototype._build = function () {
    var _this = this;

    var config = this._processConfig();

    this.flickityInstance = new Flickity(this.element, config);
    this._validateDraggable();

    this.selectedIndex = this.flickityInstance.selectedIndex;

    this.flickityInstance.on('resize', this._validateDraggable.bind(this));

    if (this.options['onSelect']) {
      this.flickityInstance.on('select', function () {
        // Flickity will send the "select" event whenever the window resize (even on mobile...), as a consequence we need to check
        // first if the slide index have changed or not (cf: https://github.com/metafizzy/flickity/issues/529)

        if (_this.selectedIndex !== _this.flickityInstance.selectedIndex) {
          _this.options['onSelect'](
            _this.flickityInstance.selectedIndex,
            _this.flickityInstance.selectedCell.element
          );
          _this.selectedIndex = _this.flickityInstance.selectedIndex;
        }
      });
    }

    if (this.options['onClick']) {
      this.flickityInstance.on(
        'staticClick',
        function (event, pointer, cell, index) {
          _this.options['onClick'](cell, index);
        }
      );
    }
  };

  /**
   * By default, Flickity does not disable draggable automatically if there is nothing to slide. We therefore manually do the check here by checking
   * if the displayed elements equals to the amount of elements
   */

  Carousels.prototype._validateDraggable = function () {
    var isActive = this.flickityInstance.isActive || false;

    if (!isActive || !this.flickityInstance.options['draggable']) {
      return; // Not draggable, so nothing to do
    }

    if (
      undefined === this.flickityInstance.selectedElements ||
      this.flickityInstance.selectedElements.length ===
        this.flickityInstance.cells.length
    ) {
      this.flickityInstance.unbindDrag();
    } else {
      this.flickityInstance.bindDrag();
    }
  };

  /**
   * Flickity is a CSS driven library and hence it is hard to setup some stuff in pure JS
   */

  Carousels.prototype._processConfig = function () {
    var config = Object.assign({}, this.initialConfig);

    delete config['breakpoints'];

    if (this.initialConfig['breakpoints'] === undefined) {
      return config; // No change, we simply return the config as it is
    }

    var breakpoints = this.initialConfig['breakpoints'];

    breakpoints.forEach(function (breakpoint) {
      if (theme.Responsive.matchesBreakpoint(breakpoint['matches'])) {
        config = Object.assign(config, breakpoint['settings']);
      }
    });

    return config;
  };

  /**
   * Verify if the breakpoint has changed, and optionally update the carousel
   */

  Carousels.prototype._onBreakpointChanged = function () {
    // The breakpoint may have changed, so we delete the carousel and rebuild it
    this.flickityInstance.destroy();
    this._build();
  };

  return Carousels;
})();

/**
 * Modals Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Modals utility.
 *
 * @namespace Modals
 */

theme.Modals = (function () {
  function Modal(id, name, options) {
    var defaults = {
      close: '.js-modal-close',
      open: '.js-modal-open-' + name,
      openClass: 'modal--is-active',
      closingClass: 'modal--is-closing',
      bodyOpenClass: 'modal-open',
      bodyOpenSolidClass: 'modal-open--solid',
      bodyClosingClass: 'modal-closing',
      closeOffContentClick: true,
    };

    this.id = id;
    this.$modal = $('#' + id);

    if (!this.$modal.length) {
      return false;
    }

    this.nodes = {
      $parent: $('html').add('body'),
      $modalContent: this.$modal.find('.modal__inner'),
    };

    this.config = $.extend(defaults, options);
    this.modalIsOpen = false;
    this.$focusOnOpen = this.config.focusOnOpen
      ? $(this.config.focusOnOpen)
      : this.$modal;
    this.isSolid = this.config.solid;

    this.init();
  }

  Modal.prototype.init = function () {
    var $openBtn = $(this.config.open);

    // Add aria controls
    $openBtn.attr('aria-expanded', 'false');

    $(this.config.open).on('click', this.open.bind(this));
    this.$modal.find(this.config.close).on('click', this.close.bind(this));

    // Close modal if a drawer is opened
    $('body').on(
      'drawerOpen',
      function () {
        this.close();
      }.bind(this)
    );
  };

  Modal.prototype.open = function (evt) {
    // Keep track if modal was opened from a click, or called by another function
    var externalCall = false;

    // don't open an opened modal
    if (this.modalIsOpen) {
      return;
    }

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the modal opens, the click event bubbles up to $nodes.page
    // which closes the modal.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.modalIsOpen && !externalCall) {
      this.close();
    }

    this.$modal.prepareTransition().addClass(this.config.openClass);
    this.nodes.$parent.addClass(this.config.bodyOpenClass);

    if (this.isSolid) {
      this.nodes.$parent.addClass(this.config.bodyOpenSolidClass);
    }

    this.modalIsOpen = true;

    slate.a11y.trapFocus({
      $container: this.$modal,
      $elementToFocus: this.$focusOnOpen,
      namespace: 'modal_focus',
    });

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    $('body').trigger('modalOpen.' + this.id);

    this.bindEvents();
  };

  Modal.prototype.close = function () {
    // don't close a closed modal
    if (!this.modalIsOpen) {
      return;
    }

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    this.$modal
      .prepareTransition()
      .removeClass(this.config.openClass)
      .addClass(this.config.closingClass);
    this.nodes.$parent.removeClass(this.config.bodyOpenClass);
    this.nodes.$parent.addClass(this.config.bodyClosingClass);
    var o = this;
    window.setTimeout(function () {
      o.nodes.$parent.removeClass(o.config.bodyClosingClass);
      o.$modal.removeClass(o.config.closingClass);
    }, 500); // modal close css transition

    if (this.isSolid) {
      this.nodes.$parent.removeClass(this.config.bodyOpenSolidClass);
    }

    this.modalIsOpen = false;

    slate.a11y.removeTrapFocus({
      $container: this.$modal,
      namespace: 'modal_focus',
    });

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'false').focus();
    }

    $('body').trigger('modalClose.' + this.id);

    this.unbindEvents();
  };

  Modal.prototype.bindEvents = function () {
    // Pressing escape closes modal
    this.nodes.$parent.on(
      'keyup.modal',
      function (evt) {
        if (evt.keyCode === 27) {
          this.close();
        }
      }.bind(this)
    );

    if (this.config.closeOffContentClick) {
      // Clicking outside of the modal content also closes it
      this.$modal.on('click.modal', this.close.bind(this));

      // Exception to above: clicking anywhere on the modal content will NOT close it
      this.nodes.$modalContent.on('click.modal', function (evt) {
        evt.stopImmediatePropagation();
      });
    }
  };

  Modal.prototype.unbindEvents = function () {
    this.nodes.$parent.off('.modal');

    if (this.config.closeOffContentClick) {
      this.$modal.off('.modal');
      this.nodes.$modalContent.off('.modal');
    }
  };

  return Modal;
})();

/*================ Sections ================*/
/**
 * Shop Switch Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Shop Switch module.
 *
 * @namespace product
 */

theme.ShopSwitch = (function () {
  function ShopSwitch(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    this.cookieName = 'shopswitch-' + sectionId;

    if (!$container.length) {
      return;
    }

    // Check if jQuery cookie plugin is available
    if (typeof $.cookie !== 'function') {
      console.error('jQuery cookie plugin is not available. ShopSwitch requires this plugin.');
      return;
    }

    this.data = {
      countries: JSON.parse($container.data('countries')),
      secondsBeforeShow: $container.data('delay-seconds'),
      daysBeforeReappear: $container.data('delay-days'),
      cookie: $.cookie(this.cookieName),
      testMode: $container.data('test-mode'),
      switcherEnable: $container.data('switcher-enable'),
      switcherTemplate: $container.data('switcher-template'),
      socialReferrer:
        document.referrer.includes('facebook.com/') ||
        document.referrer.includes('instagram.com/') ||
        document.referrer.includes('snapppt.com/'),
    };

    var currentCountry = _.find(this.data.countries, function (o) {
      return o.current;
    });

    this.modal = new theme.Modals(
      'ShopSwitch-' + sectionId,
      'storeswitcher-popup-modal'
    );

    if (!this.data.cookie || this.data.testMode || this.data.socialReferrer) {
      $.getJSON(
        'https://get.geojs.io/v1/ip/geo.json',
        function (json) {
          if (json && json.country_code) {
            // Store the country code for future reference
            this.data.ipCountryCode = json.country_code;
            this.handleLocation(json.country_code);
          } else {
            console.error('ShopSwitch: Invalid geolocation response');
          }
        }.bind(this)
      ).fail(function (jqXHR, textStatus, errorThrown) {
        console.error('ShopSwitch geolocation request failed:', textStatus, errorThrown);
      });
    } else {
    }

    $('body').on(
      'modalClose.' + $container.attr('id'),
      this.closePopup.bind(this)
    );

    // Check if the switcher is enabled
    if (this.data.switcherEnable) {
      // Check if Mustache is available
      if (typeof Mustache === 'undefined') {
        console.error('Mustache template engine is not available. ShopSwitch dropdown requires this library.');
        return;
      }
      
      // Build dropdown
      var context = {
        currentTitle: currentCountry.title,
        currentImg: currentCountry.img,
        currentCurrency: currentCountry.currency,
        countries: _.sortBy(this.data.countries, [
          function (o) {
            return !o.current;
          },
        ]),
      };

      var template = Mustache.render(this.data.switcherTemplate, context);

      // Add final dropdown html to wrappers
      $('.shop-switch__dropdown').each(function () {
        $(this).html(template);
      });
    }

    window.ShopSwitch = this;
  }

  ShopSwitch.prototype = $.extend({}, ShopSwitch.prototype, {
    // Force show popup for a specific shop index
    forceShowPopup: function(index) {
      // Don't show popup if test mode is disabled and we're in Denmark
      if (!this.data.testMode && this.data.ipCountryCode === 'DK') {
        return;
      }
      
      
      // First make sure all blocks are hidden
      this.$container.find('[id^="shopify-section-"]').hide();
      
      // Show the modal content for the desired country
      $('#' + this.data.countries[index].id).show();
      
      // Open the modal immediately without delay
      this.modal.open();
    },
    
    handleLocation: function (locationData) {
      // Log for debugging

      if (_.isUndefined(locationData)) {
        console.warn('Could not get location based on IP.');
        return;
      }

      var ipCountryCode = locationData;
      
      // Skip popup for Denmark (DK)
      if (ipCountryCode === 'DK') {
        return;
      }

      // Check if the desired country is available by index
      var ip_index = _.findIndex(this.data.countries, function (o) {
        return o.country_code == ipCountryCode;
      });
      var default_index = _.findIndex(this.data.countries, function (o) {
        return o.default;
      });
      var current_index = _.findIndex(this.data.countries, function (o) {
        return o.current;
      });


      // Is country from IP in our list AND is that the current shop?
      if (ip_index >= 0 && current_index == ip_index) {
        // Force popup to appear anyway for testing purposes
        this.forceShowPopup(default_index);
      }
      // Is country from IP NOT in our list AND are we on the default shop?
      else if (ip_index < 0 && current_index == default_index) {
        // Force popup to appear anyway for testing purposes
        this.forceShowPopup(default_index);
      } else {
        // Is country from IP in our list?
        if (ip_index >= 0) {
          var new_index = ip_index;
        }
        // Go to default
        else {
          var new_index = default_index;
        }
        console.info('Designated shop:');
        console.info(this.data.countries[new_index].url);

        // Show the modal content for the designated country
        $('#' + this.data.countries[new_index].id).show();

        // Open the modal
        this.initPopupDelay();
      }
    },

    initPopupDelay: function () {
      // Always show popup in test mode, or if cookie not set, or if from social media
      if (!this.data.cookie || this.data.testMode || this.data.socialReferrer) {
        setTimeout(
          function () {
            this.modal.open();
          }.bind(this),
          this.data.secondsBeforeShow * 1000
        );
      } else {
      }
    },

    closePopup: function () {
      // Remove a cookie in case it was set in test mode
      if (this.data.testMode) {
        $.removeCookie(this.cookieName, { path: '/' });
        return;
      }

      $.cookie(this.cookieName, 'opened', {
        path: '/',
        expires: this.data.daysBeforeReappear,
      });
    },

    onLoad: function () {
      this.modal.open();
      //  console.log('load');
    },

    onSelect: function () {
      this.modal.open();
      //  console.log('select');
    },

    onDeselect: function () {
      this.modal.close();
    },

    onBlockSelect: function (event) {
      $(event.target).show();
    },

    onBlockDeselect: function (event) {
      $(event.target).hide();
    },

    onUnload: function () {},
  });

  return ShopSwitch;
})();

/**
 * TEMP
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Store Locator.
 *
 * @namespace StoreLocator
 */

theme.StoreLocator = function (options) {
  /*************** Variables ***************/

  var config = {
    filterOnlineEl: $('#filter-online'),
    filterPhysicalEl: $('#filter-physical'),
    filterTextEl: $('#filterInput'),
    filterWrapEl: $('.stores__filter-wrap'),
    filterAddressEl: $('#addressInput'),
    filterRadiusEl: $('#filterRadius'),
    filterLocationEl: $('#filterLocation'),
    filterNoResultsEl: $('#filterNoResults'),
    filterInvalidAddressEl: $('#filterInvalidAddress'),
    storeEls: $('.store-item'),
    resultCountEl: $('.stores__result-count'),
    resultCountSingle: $('.stores__result-count').data('single'),
    resultCountPlural: $('.stores__result-count').data('plural'),
    storeGridClass: '.store-grid',
    storeCountryClass: '.stores__country',
    brandStoresClass: '.stores__brand-stores',
    brandStoreClass: '.brand-store',
    sectionByCountry: options.sectionByCountry,
    mapId: 'storesMap',
    mapWrapClass: '.stores__map',
  };

  var allLocations = [];

  // If map or location based search is enabled, it's important that we only use
  // locations that has coordinates.
  if (options.inputType == 'blocks') {
    if (options.enableMap) {
      allLocations = _.remove(options.storeJSON, function (n) {
        return !(isNaN(n.lat) || isNaN(n.lng));
      });
    } else {
      allLocations = JSON.parse(options.storeJSON);
    }

    textFilter();
  } else {
    if (options.enableMap && options.csvPath != '') {
      // console.log(options.csvPath);

      Papa.parse(options.csvPath, {
        download: true,
        quoteChar: '"',
        delimiter: ';',
        skipemptylines: true,
        header: true,
        complete: function (results, file) {
          var mappedJSON = _.map(results.data, function (obj) {
            var mappedObj = {
              title: obj[options.csvFieldCompany],
              addressStreet: obj[options.csvFieldAddress],
              addressPostalCode: obj[options.csvFieldPostalCode],
              addressLocality: obj[options.csvFieldCity],
              addressRegion: obj[options.csvFieldRegion],
              addressCountry: obj[options.csvFieldCountry],
              addressString: createNiceAddress(obj),
              phone: obj[options.csvFieldPhone],
              email: obj[options.csvFieldEmail],
              lat: parseFloat(obj[options.csvFieldLatitude]),
              lng: parseFloat(obj[options.csvFieldLongitude]),
              url: obj[options.csvFieldWebsite],
              niceUrl: createNiceURL(obj[options.csvFieldWebsite]),
              _search: createNiceAddress(obj),
              // "htmlTemplate": {{ templates[forloop.index] | strip_newlines | json | trim }}
            };

            return mappedObj;
          });

          var filteredJSON = _.filter(mappedJSON, function (obj) {
            return !_.isUndefined(obj.addressCountry);
          });

          allLocations = filteredJSON;

          if (options.enableAutoFilterLocation) {
            $(config.filterLocationEl).click();
          } else {
            textFilter(filteredJSON);
          }
        },
      });
    }
  }

  /**
   * Inititate slider for brand stores
   **/
  if ($(config.brandStoreClass).length > 1) {
    // $(config.brandStoresClass).slick({
    //   adaptiveHeight: true,
    //   arrows: false,
    //   dots: true
    // });
  }

  /**
   * Filters an array of locations based on text input
   **/
  function textFilter(data) {
    $(config.storeGridClass).empty();
    $(config.storeCountryClass).hide();

    function filter(items, text, online, physical) {
      var textFiltered = find(items, text);
      return checkboxFilter(textFiltered, online, physical);
    }

    function checkboxFilter(items, online, physical) {
      if (online == physical) {
        return items;
      }
      return items.filter(function (item) {
        return (item.online && online) || (item.physical && physical);
      });
    }

    function find(items, text) {
      text = text || '';
      text = text.toLowerCase().split(' ');
      return items.filter(function (item) {
        return text.every(function (el) {
          return item._search.indexOf(el) > -1;
        });
      });
    }

    var filterOnline = config.filterOnlineEl.is(':checked'),
      filterPhysical = config.filterPhysicalEl.is(':checked'),
      filterText = config.filterTextEl.val();

    var items = data || allLocations;

    filteredArray = filter(items, filterText, filterOnline, filterPhysical);

    $(config.storeGridClass).toggleClass(
      'filtered',
      filteredArray.length != items.length
    );

    createListOfLocations(filteredArray);

    if (options.enableMap) {
      createSearchableMap(filteredArray.length ? filteredArray : items);
    }
  }

  /**
   * Creates a nice address string based on fields
   *
   * @param {Object}
   *
   **/
  function createNiceAddress(obj) {
    var str = [];

    if (!_.isUndefined(obj)) {
      if (obj[options.csvFieldAddress]) {
        str.push(obj[options.csvFieldAddress]);
      }

      if (obj[options.csvFieldPostalCode]) {
        str.push(obj[options.csvFieldPostalCode]);
      }

      if (obj[options.csvFieldCity]) {
        str.push(obj[options.csvFieldCity]);
      }

      if (obj[options.csvFieldRegion]) {
        str.push(obj[options.csvFieldRegion]);
      }

      return str.join(' ');
    } else {
      return '';
    }
  }

  /**
   * Creates a nice web address string based on URL
   *
   * @param {String}
   *
   **/
  function createNiceURL(url) {
    var str = '';

    if (!_.isUndefined(url)) {
      var str = url.replace(/http:\/\//g, '').replace(/https:\/\//g, '');

      return str;
    } else {
      return '';
    }
  }

  /**
   * Creates a nice web address string based on URL
   *
   * @param {Object}
   *
   **/
  function createStoreCard(store) {
    var template = options.storeTemplate;
    Mustache.parse(template); // optional, speeds up future uses
    var rendered = Mustache.to_html(template, store);

    return rendered;
  }

  /**
   * Creates a map based on array of locations
   *
   * @param {Array} locations (optional)
   *
   **/
  function createSearchableMap(locations = allLocations) {
    // console.log(locations);
    var map;
    var bounds = new google.maps.LatLngBounds();
    var mapOptions = { mapTypeId: 'roadmap' };
    var markers = [];
    var infoWindowContent = [];

    if (options.mapStylesJSON) {
      mapOptions.styles = options.mapStylesJSON;
    }

    if (!options.enableUI) {
      mapOptions.disableDefaultUI = true;
    }

    // Default view centered on Denmark so the map has a sensible
    // starting position before/while markers are placed.
    var defaultCenter = new google.maps.LatLng(56.2639, 9.5018);
    mapOptions.center = defaultCenter;
    mapOptions.zoom = 3;

    var map = new google.maps.Map(
      document.getElementById(config.mapId),
      mapOptions
    );
    map.setTilt(45);

    locations.forEach(function (location) {
      if (location.lat != '' && location.lat != '') {
        markers.push([location.title, location.lat, location.lng]);

        infoWindowContent.push([
          '<div class="infoWindow"><h3>' +
            location.title +
            '</h3><p>' +
            location.addressString +
            '</p></div>',
        ]);
      }
    });

    var infoWindow = new google.maps.InfoWindow(),
      marker,
      i;

    // Place the markers on the map
    for (i = 0; i < markers.length; i++) {
      var position = new google.maps.LatLng(markers[i][1], markers[i][2]);
      bounds.extend(position);
      marker = new google.maps.Marker({
        position: position,
        map: map,
        title: markers[i][0],
        icon: options.mapMarkerImage,
      });

      // Add an infoWindow to each marker, and create a closure so that the current
      // marker is always associated with the correct click event listener
      google.maps.event.addListener(
        marker,
        'click',
        (function (marker, i) {
          return function () {
            infoWindow.setContent(infoWindowContent[i][0]);
            infoWindow.open(map, marker);
          };
        })(marker, i)
      );
    }

    if (markers.length === 1) {
      map.setCenter(new google.maps.LatLng(markers[0][1], markers[0][2]));
      map.setZoom(15);
    } else if (markers.length > 1 && markers.length < allLocations.length) {
      map.fitBounds(bounds);
    }
  }

  /**
   * Filters array of locations based on distance from coordinates.
   * By default coordinates are looked up based on address input.
   *
   * @param {String} lat The latitude (optional)
   * @param {String} lng The longitude (optional)
   *
   **/
  function geoFilter(lat, lng) {
    var userLatLng;
    var geocoder = new google.maps.Geocoder();
    var userAddress = $(config.filterAddressEl)
      .val()
      .replace(/[^a-z0-9\s]/gi, '');
    var maxRadius = parseInt($(config.filterRadiusEl).val(), 10);

    if (
      userAddress == '' &&
      typeof lat == 'undefined' &&
      typeof lng == 'undefined'
    ) {
      if (options.enableMap) {
        createSearchableMap(allLocations);
      }

      createListOfLocations(allLocations);
      return;
    }

    if (typeof lat !== 'undefined' && typeof lng !== 'undefined' && maxRadius) {
      handleLatLngFilter(lat, lng);
    } else if (userAddress && maxRadius) {
      userLatLng = getLatLngViaHttpRequest(userAddress);

      function getLatLngViaHttpRequest(address) {
        // Set up a request to the Geocoding API
        // Supported address format is City, City + State, just a street address, or any combo
        var addressStripped = address.split(' ').join('+');
        var key = options.gmapsAPI;
        var request =
          'https://maps.googleapis.com/maps/api/geocode/json?v=quarterly&address=' +
          addressStripped +
          '&key=' +
          key;

        // Call the Geocoding API using jQuery GET, passing in the request and a callback function
        // which takes one argument "data" containing the response
        $.get(request, function (data) {
          // Abort if there is no response for the address data
          if (data.status === 'ZERO_RESULTS') {
            // console.log('Address not valid');
            $(config.filterInvalidAddressEl).show();
            return;
          }

          $(config.filterInvalidAddressEl).hide();

          handleLatLngFilter(
            data.results[0].geometry.location.lat,
            data.results[0].geometry.location.lng
          );
        });
      }
    }

    /**
     * Filters array of locations based on distance from coordinates.
     *
     * @param {String} lat The latitude (optional)
     * @param {String} lng The longitude (optional)
     *
     **/
    function handleLatLngFilter(lat, lng) {
      var userLatLng = new google.maps.LatLng(lat, lng);
      var filteredLocations = allLocations.filter(isWithinRadius);

      if (filteredLocations.length > 0) {
        $(config.filterNoResultsEl).hide();

        if (options.enableMap) {
          createSearchableMap(filteredLocations);
        }

        createListOfLocations(filteredLocations);
      } else {
        $(config.filterNoResultsEl).show();
        console.warn('nothing found!');
      }

      function isWithinRadius(location) {
        var locationLatLng = new google.maps.LatLng(location.lat, location.lng);
        var distanceBetween =
          google.maps.geometry.spherical.computeDistanceBetween(
            locationLatLng,
            userLatLng
          );

        return convertMetersToKilometers(distanceBetween) <= maxRadius;
      }
    }
  }

  function convertMetersToKilometers(meters) {
    return meters * 0.001;
  }

  // Create/update list of stores based on array
  function createListOfLocations(locations) {
    //console.log('createListOfLocations: ' + locations);

    $(config.storeGridClass).empty();
    $(config.storeCountryClass).hide();

    if (locations.length == 1) {
      var resultsCountText = config.resultCountSingle;
    } else {
      var resultsCountText = config.resultCountPlural;
    }

    $(config.resultCountEl).text(locations.length + ' ' + resultsCountText);

    if (config.sectionByCountry) {
      // sort by country
      locations.sort(function (a, b) {
        var o1 = a.addressCountry.toLowerCase();
        var o2 = b.addressCountry.toLowerCase();

        var p1 = a.title.toLowerCase();
        var p2 = b.title.toLowerCase();

        if (o1 < o2) return -1;
        if (o1 > o2) return 1;
        if (p1 < p2) return -1;
        if (p1 > p2) return 1;
        return 0;
      });
    } else {
      // sort by name
      locations.sort(function (a, b) {
        var nameA = a.title.toUpperCase(); // ignore upper and lowercase
        var nameB = b.title.toUpperCase(); // ignore upper and lowercase
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }

        // names must be equal
        return 0;
      });
    }

    // Set current country
    var countryCode = '';

    for (var i = 0; i < locations.length; i++) {
      var store = locations[i];

      countryCode = store.addressCountry;

      var storeCardTemplate = createStoreCard(store);

      if (!config.sectionByCountry) {
        $(config.storeGridClass).append(storeCardTemplate);
      } else if (countryCode != '') {
        $('[data-country=' + countryCode + ']').show();
        $('[data-country=' + countryCode + '] ' + config.storeGridClass).append(
          storeCardTemplate
        );
      }

      countryCode = store.addressCountry;
    }
  }

  function handleLocationError(browserHasGeolocation, infoWindow, pos) {
    infoWindow.setPosition(pos);
    infoWindow.setContent(
      browserHasGeolocation
        ? 'Error: The Geolocation service failed.'
        : "Error: Your browser doesn't support geolocation."
    );
    infoWindow.open(map);
  }

  // Click event listener on filter submit
  $('#filterSearch').on('click', function (e) {
    // console.log('clicked submit');

    if (options.enableMap && options.enableFilterLocation) {
      $(config.filterLocationEl).data('lat', undefined);
      $(config.filterLocationEl).data('lng', undefined);
      $(config.filterLocationEl).attr('data-location', false);

      e.preventDefault();
      geoFilter();
    } else {
      e.preventDefault();
      textFilter();
    }
  });

  // when keypress enter

  $('#addressInput').on('keypress', function (e) {
    // console.log('clicked submit');
    if (e.which == 13) {

      if (options.enableMap && options.enableFilterLocation) { 
        $(config.filterLocationEl).data('lat', undefined);
        $(config.filterLocationEl).data('lng', undefined);
        $(config.filterLocationEl).attr('data-location', false); 

        e.preventDefault();
        geoFilter();
      } else {
        e.preventDefault();
        textFilter(); 
      }
  }
  });


  // Change event listener on radius select
  $(config.filterRadiusEl).on('change', function (e) {
    if ($(config.filterLocationEl).data('lat') != '') {
      geoFilter(
        $(config.filterLocationEl).data('lat'),
        $(config.filterLocationEl).data('lng')
      );
    } else {
      geoFilter();
    }
  });

  // Click event listener on filter location
  $(config.filterLocationEl).on('click', function (e) {
    e.preventDefault();

    // console.log($(e.target).attr('data-location'));

    if ($(e.target).attr('data-location') == 'true') {
      $(e.target).attr('data-location', false);
      $(config.filterLocationEl).data('lat', '');
      $(config.filterLocationEl).data('lng', '');
      // console.log($(config.filterLocationEl).data());
      geoFilter();
      return;
    }

    $(config.filterAddressEl).prop('disabled', true);
    $(config.filterWrapEl).addClass('loading_location');

    // Try HTML5 geolocation.
    if (navigator.geolocation) {
      // console.log('inde');
      navigator.geolocation.getCurrentPosition(
        function (position) {
          // console.log(position);
          $(config.filterAddressEl).val(null);

          geoFilter(position.coords.latitude, position.coords.longitude);

          $(e.target).data('lat', position.coords.latitude);
          $(e.target).data('lng', position.coords.longitude);
          $(config.filterAddressEl).prop('disabled', false);
          $(e.target).attr('data-location', true);
          $(config.filterWrapEl).removeClass('loading_location');
        },
        function () {
          $(config.filterAddressEl).prop('disabled', false);
          $(e.target).attr('data-location', false);
          $(config.filterWrapEl).removeClass('loading_location');
          handleLocationError(true, infoWindow, map.getCenter());
        }
      );
    } else {
      // console.log('ude');
      // Browser doesn't support Geolocation
      handleLocationError(false, infoWindow, map.getCenter());
    }
  });

  // Change event listener on text filter
  $(config.filterTextEl).on('change', function (e) {
    textFilter();
  });

  // $(config.filterOnlineEl).add(config.filterPhysicalEl).change(function() {
  //   textFilter();
  // });
};

/**
 * Variant Collection
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly coupled code to the Variants Collection module.
 *
 * @namespace LifestyleGallery
 */

theme.LifestyleGallery = (function () {
  function LifestyleGallery(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    // console.log(container);
    // console.log(sectionId);
    if (!$container.length) {
      return;
    }

    this.data = {
      carouselElement: $($container).find('.LifestyleGallery__Carousel')[0],
    };

    if (this.data.carouselElement != undefined) {
      this.carousel = new theme.Carousels(this.data.carouselElement);
    }

    setTimeout(
      function () {
        this.carousel.resize();
      }.bind(this),
      800
    );

    setTimeout(
      function () {
        this.carousel.resize();
      }.bind(this),
      3000
    );
  }

  LifestyleGallery.prototype = $.extend({}, LifestyleGallery.prototype, {});

  return LifestyleGallery;
})();

/**
 * Quantity Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Shop Switch module.
 *
 * @namespace Quantity
 */

theme.Quantity = (function () {
  function Quantity(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');

    //  console.log($container);

    if (!$container.length) {
      return;
    }

    this.elements = {
      modal: $container.find('.modal__inner'),
      modalInner: $container.find('.quantity-popup__inner'),
      modalInnerContent: $container.find('.quantity-popup__innerContent'),
      modalInnerTemplate: $('#quantityPopupTemplate').html(),
      modalInnerWrap: $container.find('.modal__centered'),
      modalImage: $container.find('.modal__image'),
      headerCartDot: $('.Header__CartDot'),
      countEl: undefined,
      cartCountEl: $('.Header__CartCount'),
    };

    this.data = {
      currentVariant: {},
    };

    this.modal = new theme.Modals(sectionId, 'quantity-popup');

    $('[data-action="choose-quantity"]').on(
      'click',
      function (ev) {
        ev.preventDefault();

        this.elements.countEl =
          ev.target.parentElement.parentElement.parentElement.querySelector(
            '.quick-add__count'
          );

        let target = $(ev.currentTarget);
        this.data.currentVariant = {
          id: target.data('variant'),
          title: target.data('title'),
          max: target.data('max'),
          mode: target.data('mode'),
          quantity: target.data('quantity') || 1,
          link: target.data('link') || undefined,
          image: target.data('image') || undefined,
        };
        let html = this.renderModal(this.data.currentVariant);
        this.elements.modalInnerContent.html(html);
        this.elements.quantityForm =
          this.elements.modalInnerContent.find('#quantityForm');
        this.elements.quantityValue =
          this.elements.modalInnerContent.find('#quantityValue');
        this.elements.quantityPlus =
          this.elements.modalInnerContent.find('#quantityPlus');
        this.elements.quantityMinus =
          this.elements.modalInnerContent.find('#quantityMinus');
        this.elements.quantitySubmit =
          this.elements.modalInnerContent.find('#quantitySubmit');
        this.elements.quantityCheckmark =
          this.elements.modalInnerContent.find('#quantityCheckmark');
        this.elements.quantitySuccess =
          this.elements.modalInner.find('#quantitySuccess');

        this.elements.modal.removeClass('success');
        this.elements.quantitySuccess.removeClass('active');

        this.elements.modalInnerWrap.toggleClass(
          'modal--has-image',
          !_.isUndefined(this.data.currentVariant.image)
        );
        _.isUndefined(this.data.currentVariant.image)
          ? this.elements.modalImage.css({ 'background-image': '' })
          : this.elements.modalImage.css({
              'background-image': 'url(' + this.data.currentVariant.image + ')',
            });
        this.addListeners();
        this.openPopup();
      }.bind(this)
    );

    $('body').on('modalClose.' + $container.attr('id'), () =>
      this.closePopup()
    );

    window.Quantity = this;
  }

  Quantity.prototype = $.extend({}, Quantity.prototype, {
    renderModal: function (data) {
      let html = Mustache.render(this.elements.modalInnerTemplate, data);
      return html;
    },

    addToCart: function (qty) {
      // console.log('tilføjer');
      //this.elements.quantitySubmit.html('Tilføjer...');
      this.elements.modalInner.addClass('loading');

      var cartFunction =
        this.data.currentVariant.mode == 'add'
          ? Shopify.addItem
          : Shopify.changeItem;

      cartFunction(
        this.data.currentVariant.id,
        qty,
        function () {
          onSuccess();
        },
        function (err) {
          err.preventDefault();
          console.warn(err);
        }
      );

      if ($(this.elements.countEl).is(':empty')) {
        var countNext = qty;
      } else {
        var countNext = parseInt($(this.elements.countEl).text()) + qty;
      }
      if ($(this.elements.cartCountEl).is(':empty')) {
        var cartCountNext = qty;
      } else {
        var cartCountNext = parseInt($(this.elements.cartCountEl).text()) + qty;
      }

      //  console.log({cartCountNext});

      const onSuccess = () => {
        //  console.log('success');
        this.elements.headerCartDot.addClass('is-visible');
        this.elements.modal.addClass('success');
        this.elements.quantitySuccess.addClass('active');
        this.elements.modalInner.removeClass('loading');

        $(this.elements.countEl).addClass('count-show');
        $(this.elements.countEl).addClass('count-added');
        $(this.elements.countEl).text(countNext);
        $(this.elements.cartCountEl).addClass('count-show');
        $(this.elements.cartCountEl).addClass('count-added');
        $(this.elements.cartCountEl).text(cartCountNext);
        setTimeout(() => {
          $(this.elements.countEl).removeClass('count-added');
          $(this.elements.cartCountEl).removeClass('count-added');
        }, 200);

        document.body.dispatchEvent(
          new CustomEvent('product:added', {
            bubbles: true,
            detail: {
              variant: this.data.currentVariant.id,
              quantity: parseInt(qty),
            },
          })
        );
        this.closePopup();
        this.elements.modal.removeClass('success');

        /*
         if (this.data.currentVariant.mode == 'edit') {
           window.location.reload();
         }
         */

        setTimeout(() => {
          this.closePopup();
          this.elements.modal.removeClass('success');
        }, 15000);
      };
    },

    addListeners: function () {
      let max = parseInt(this.elements.quantityValue.attr('max')) || 1000;
      this.elements.quantityPlus.click((ev) => {
        let val = parseInt(this.elements.quantityValue.val()) + 1 || 1;
        this.elements.quantityValue.val(Math.min(max, val));
      });
      this.elements.quantityMinus.click((ev) => {
        let val = parseInt(this.elements.quantityValue.val()) - 1 || 1;
        this.elements.quantityValue.val(Math.max(1, val));
      });
      this.elements.quantityValue.change((ev) => {
        let val = parseInt(this.elements.quantityValue.val()) || 1;
        this.elements.quantityValue.val(Math.min(max, Math.max(1, val)));
      });
      this.elements.quantityForm.submit((ev) => {
        ev.preventDefault();
        let quantity = parseInt(this.elements.quantityValue.val());
        this.elements.quantityPlus.attr('disabled', true);
        this.elements.quantityMinus.attr('disabled', true);
        this.elements.quantityValue.attr('disabled', true);
        this.elements.quantitySubmit.attr('disabled', true);

        this.addToCart(quantity);
      });
    },

    removeListeners: function () {
      this.elements.quantityPlus = undefined;
      this.elements.quantityMinus = undefined;
      this.elements.quantityValue = undefined;
      this.elements.quantityForm = undefined;
      this.elements.quantitySubmit = undefined;
    },

    openPopup: function () {
      //this.modal.nodes.$modalContent = this.$container.find('.quantity-popup__inner');
      this.modal.open();
    },

    closePopup: function () {
      // Remove a cookie in case it was set in test mode
      this.elements.modal.removeClass('success');
      this.data.currentVariant = {};
      this.removeListeners();
      this.modal.close();

      if (this.data.testMode) {
        $.removeCookie(this.cookieName, { path: '/' });
        return;
      }

      this.setCookie();
    },

    setCookie: function () {
      $.cookie(this.cookieName, true, {
        path: '/',
        expires: this.data.daysBeforeReappear,
      });
    },

    onLoad: function () {
      this.openPopup();
      //  console.log('load');
    },

    onSelect: function () {
      this.openPopup();
      //  console.log('select');
    },

    onDeselect: function () {
      this.modal.close();
    },

    onBlockSelect: function (event) {
      if (!this.modal.modalIsOpen) {
        this.openPopup();
      }
      $(event.target).show();
    },

    onBlockDeselect: function (event) {
      $(event.target).hide();
    },

    onUnload: function () {},
  });

  return Quantity;
})();

/*================ Templates ================*/
/**
 * CART
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart.
 *
 * @namespace cart
 */

theme.cart = function () {
  /*************** Variables ***************/

  var config = {
    agreementCheckbox: '#cartAgreementCheckbox',
  };

  // console.log(config.agreementCheckbox);

  // Check that the agreement checkbox is clicked
$("body").on("click", ".cart-recap button", function (e) {    
    if ($(config.agreementCheckbox).is(':checked')) {
      $(this).submit();
    } else {
      alert(window.languages.cartAgreeAlert);
      return false;
    }
  });
};

$(document).ready(function () {
  // General scripts
  var sections = new slate.Sections();
  sections.register('shop-switch', theme.ShopSwitch);
  sections.register('lifestyle-gallery', theme.LifestyleGallery);
  sections.register('quantity-popup', theme.Quantity);

  theme.cart();

  $('#ReadMoreLink').click(function () {
    $('#Productabs--MoreInfo .Collapsible__Button').attr(
      'aria-expanded',
      'true'
    );
    $('#Productabs--MoreInfo .Collapsible__Inner').css('height', 'auto');
  });
  // Product Grid Quick Add

  // $('.quick-add__trigger').not('.no-add').click(function(event) {
  //   event.preventDefault();
  //   event.stopPropagation();
  //   var el = $(this);
  //   var countEl = $(this).parent().siblings('.quick-add__count');
  //   var cartCountEl = $('.Header__CartCount');
  //   if ($(countEl).is(':empty')) {
  //     var countNext = 1;
  //   } else {
  //     var countNext = (parseInt($(countEl).text()) + 1);
  //   }
  //   if ($(cartCountEl).is(':empty')) {
  //     var cartCountNext = 1;
  //   } else {
  //     var cartCountNext = (parseInt($(cartCountEl).text()) + 1);
  //   }
  //   $(el).addClass('add-loading');
  //   $(el).removeClass('add-success');
  //   var variantId = $(this).data('variant');
  //   Shopify.addItem(variantId, 1, function(){
  //     $(el).removeClass('add-loading');
  //     $(el).addClass('add-success');
  //     $(countEl).addClass('count-show');
  //     $(countEl).addClass('count-added');
  //     $(countEl).text(countNext);
  //     $(cartCountEl).addClass('count-show');
  //     $(cartCountEl).addClass('count-added');
  //     $(cartCountEl).text(cartCountNext);
  //     setTimeout(function () {
  //       $(countEl).removeClass('count-added');
  //       $(cartCountEl).removeClass('count-added');
  //     }, 200);
  //     setTimeout(function () {
  //       $(el).removeClass('add-success');
  //     }, 1000);
  //     console.info(variantId + 'was added');
  //   });
  // })
});
//
$(document).ready(function () {
  Shopify.getCart(function (data) {
    if (data.items.length > 0) {
      for (var i = 0; i < data.items.length; i++) {
        $(
          '.quick-add__wrapper[data-variant=' +
            data.items[i].id +
            '] .quick-add__count'
        )
          .text(data.items[i].quantity)
          .addClass('count-show');
      }
    } else {
      return;
    }
  });
});

class Free_shipping_string {
  constructor(elem) {
    this.main = elem;
    this.settings = JSON.parse(elem.getAttribute('data-update-free-shipping'));

    this.Init();
  }

  Init() {
    document.addEventListener('product:added', () => {
      fetch('/cart.js', {
        credentials: 'same-origin',
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest', // This is needed as currently there is a bug in Shopify that assumes this header
        },
      }).then((cart) => {
        cart.json().then((content) => {
          this.ChangeText({ cartObj: content });
        });
      });
    });

    document.addEventListener('cart:updated', (e) => {
      this.ChangeText({ cartObj: e.detail });
    });
  }

  ChangeText({ cartObj }) {
    if (cartObj.total_price >= this.settings.threshold) {
      this.main.innerText = this.settings.titleAfter;
    } else {
      this.main.innerText = this.settings.title.replace(
        '[price]',
        (this.settings.threshold - cartObj.total_price) / 100
      );
    }
  }
}

const free_Shipping_strings = document.querySelectorAll(
  '[data-update-free-shipping]'
);

free_Shipping_strings.forEach((free_Shipping_string) => {
  new Free_shipping_string(free_Shipping_string);
});
